import React from 'react';
import { st, classes, cssStates } from '../VerticalTabsItem.st.css';
import { VerticalTabsItemProps } from '../VerticalTabsItem.types';
import { VerticalTabsContextValue } from '../../VerticalTabs/VerticalTabsContext';
import { Affix } from './Affix';
import { DATA_HOOKS } from '../VerticalTabsItem.constants';
import TextButton from '../../TextButton';
import { SIZE } from '../../VerticalTabs/VerticalTabs.constants';

export type ActionItemProps = Pick<
  VerticalTabsItemProps,
  'children' | 'dataHook' | 'prefixIcon' | 'suffixIcon'
> & {
  baseSkin?: VerticalTabsContextValue['skin'];
  size?: VerticalTabsContextValue['size'];
};

const ActionItem = ({
  children,
  dataHook,
  prefixIcon,
  suffixIcon,
  size,
  baseSkin,
}: ActionItemProps) => (
  <div
    className={st(
      classes.root,
      cssStates({
        size,
        baseSkin,
        suffixIcon: !!suffixIcon,
        prefixIcon: !!prefixIcon,
      }),
    )}
    data-hook={dataHook}
  >
    <Affix
      dataHook={DATA_HOOKS.ITEM_PREFIX_ICON}
      size={size}
      className={st(classes.prefixIcon, { action: true })}
    >
      {prefixIcon}
    </Affix>

    <TextButton
      weight="thin"
      className={classes.textButton}
      size={size === SIZE.TINY ? SIZE.SMALL : size}
      dataHook={DATA_HOOKS.ITEM_TEXT}
    >
      {children}
    </TextButton>

    <Affix
      dataHook={DATA_HOOKS.ITEM_SUFFIX_ICON}
      size={size}
      className={classes.suffixIcon}
    >
      {suffixIcon}
    </Affix>
  </div>
);

export { ActionItem };
